/**
 * @desc 开启流程
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<defs.activiti.ActivitiProcessInstanceDto>;
export function request(
  body: defs.activiti.ActivitiStartBusinessDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/startProcessInstanceGetInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
